import { AppSettings } from '../app.settings';
import { VehicleTransferScreenFiltersDataModel } from './vehicle-transfer-screen-filters-data-model';

export class VehicleTransferScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: VehicleTransferScreenFiltersDataModel = new VehicleTransferScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: VehicleTransferScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
